import { isMobileDevice } from '@panel/commons/helpers';
import { useQuery } from '@panel/commons/hooks';
import React, { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { site } from '@panel/commons/helpers/siteUtils';
import { currenciesBySite } from '@panel/commons/helpers/currenciesBySite';
import { selectProduct } from '../../../../ducks/step4Module2';
import { updateLastStep } from '../../../../ducks/stepper';
import {
  Title,
  SubTitleSuggestion,
  OverflowWrapper,
  CardsScrollArea,
  ButtonContainer,
  ScrollButton,
  OtherPlansContainer
} from '../styles';
import { Step1Module1Selectors } from '../../../../ducks/step1Module1';
import { CommonCards } from './commonCards';

const CardSelector = ({
  products,
  symbol,
  siteId,
  isUpgrade,
  successFlow,
  planName,
  availablePlans,
  freeAvailable
}) => {
  const [overflows, setOverflow] = useState(false);
  const [scrollId, setScrollId] = useState(0);
  const [scrollData, setScrollData] = useState({ canGoLeft: false, canGoRight: true });
  const [mobileCardInView, setMobileCardInView] = useState(0);
  const [validator, setValidator] = useState(true);
  const { operationTypeId } = useSelector(Step1Module1Selectors.getInfoEvents);
  const {
    propertySubTypes,
    propertyTypes,
    formValues: { selectedPropertyTypeId, selectedPropertySubTypeId }
  } = useSelector(Step1Module1Selectors.getStep1Module1State);
  const [postingId] = useQuery(useLocation(), ['postingId']);
  const isMobile = isMobileDevice();
  const { push } = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const refe = useRef();
  const { code } = Object.values(currenciesBySite[siteId])[0];
  const freemiumFilter =
    availablePlans.filter(
      availablePlan => availablePlan.publicationPlan.name && availablePlan.publicationPlan.name.includes('Freemium')
    ).length === 0;
  const freemiumValidations = !freemiumFilter && !freeAvailable && availablePlans.length <= 1;
  const propertyObj = { list: propertyTypes, id: selectedPropertyTypeId };
  const subPropertyObj = { list: propertySubTypes, id: selectedPropertySubTypeId };

  useEffect(() => {
    if (products.length > 0 && validator === true) {
      const productInfo = products.map(product => {
        return {
          id: product.id,
          name: product.name,
          price: product.formatUnitPrice ? product.formatUnitPrice : 0,
          category: 'Aviso Particulares',
          position: products.indexOf(product) + 1,
          list: 'Publicador de avisos'
        };
      });
      window.dataLayer.push({
        event: 'productImpression',
        ecommerce: {
          currencyCode: code,
          impressions: productInfo,
          flow_type: 'particular'
        }
      });
      setValidator(false);
    }
  }, [code, products, validator]);

  const setScrollLimits = el => {
    const canGoRight = (100 * el.current.scrollLeft) / (el.current.scrollWidth - el.current.clientWidth) < 99;
    const canGoLeft = el.current.scrollLeft > 0;
    if (canGoLeft !== scrollData.canGoLeft || canGoRight !== scrollData.canGoRight) {
      setScrollData({ canGoLeft, canGoRight });
    }
    return null;
  };

  const centerCard = cardIndex => {
    const viewCard = document.getElementById(`card-${cardIndex}`);
    viewCard.scrollIntoView({ inline: 'center' });
  };

  const handleProductSelection = productId => {
    const product = products.find(p => p.id === productId);
    const pathFlow = successFlow ? '/publicador/planes/pago/exito' : '/publicador/planes/pago';
    dispatch(selectProduct(product));
    dispatch(updateLastStep('4', '1'));
    push({
      pathname: pathFlow,
      search: `?postingId=${postingId}`,
      state: { successFlow }
    });
  };

  const handleEvent = card => {
    window.dataLayer.push({
      event: 'addToCart',
      ecommerce: {
        add: {
          products: [
            {
              id: card.id,
              name: card.name,
              price: card.formatUnitPrice,
              category: 'Aviso Particulares',
              quantity: '1'
            }
          ]
        },
        flow_type: 'particular'
      }
    });
  };
  return (
    <>
      {availablePlans.length > 0 && !freemiumValidations && (
        <Title data-repa='step4-cardSelector-title' separator={!isUpgrade} upgrade={isUpgrade}>
          {isUpgrade
            ? t('publisher.step4.module1.buyPlans.upgrade.title')
            : t('publisher.step4.module1.buyPlans.title')}
        </Title>
      )}
      <SubTitleSuggestion data-repa='step4-cardSelector-subTitle' upgrade={isUpgrade}>
        {isUpgrade ? t('publisher.step4.module1.buyPlans.upgrade.text') : t('publisher.step4.module1.buyPlans.text')}
      </SubTitleSuggestion>
      <OverflowWrapper
        data-repa='step4-cardSelector-overflowWrapper'
        onChange={isOverflowed => setOverflow(isOverflowed)}
      >
        <CardsScrollArea data-repa='step4-cardSelector-overflowWrapper-scrollArea'>
          <ButtonContainer data-repa='step4-cardSelector-overflowWrapper-buttonContainerLeft'>
            <ScrollButton
              data-repa='step4module1-productsArea-scrollButtonLeft'
              left
              show={scrollData.canGoLeft}
              len={products && products.length}
              onMouseDown={() => {
                if (!isMobile) {
                  const scrollIdIzq = setInterval(() => {
                    refe.current.scrollBy({ left: -160, top: 0, behaviour: 'smooth' });
                  }, 150);
                  setScrollId(scrollIdIzq);
                }
                return null;
              }}
              onClick={() => {
                if (!isMobile) {
                  refe.current.scrollBy({ left: -160, top: 0, behaviour: 'smooth' });
                  return null;
                }
                if (mobileCardInView >= 1 && isMobile) {
                  setMobileCardInView(mobileCardInView - 1);
                  centerCard(mobileCardInView - 1);
                }
                return null;
              }}
              onMouseUp={() => {
                if (!isMobile) {
                  clearInterval(scrollId);
                }
              }}
              onMouseLeave={() => {
                if (!isMobile) {
                  clearInterval(scrollId);
                }
              }}
            />
          </ButtonContainer>
          <OtherPlansContainer
            data-repa='step4-cardSelector-overflowWrapper-otherPlans'
            ref={refe}
            isBrasil={site.isBrasil}
          >
            <CommonCards
              products={products}
              isUpgrade={isUpgrade}
              symbol={symbol}
              setScrollLimits={setScrollLimits}
              handleEvent={handleEvent}
              handleProductSelection={handleProductSelection}
              refe={refe}
              propertyObj={propertyObj}
              operationTypeId={operationTypeId}
              planName={planName}
              subPropertyObj={subPropertyObj}
              isMobile={isMobile}
            />
          </OtherPlansContainer>
          <ButtonContainer data-repa='step4-cardSelector-buttonContainerRight'>
            <ScrollButton
              data-repa='step4module1-productsArea-scrollButtonRight'
              right
              show={scrollData.canGoRight && overflows && mobileCardInView < products.length - 1}
              onMouseDown={() => {
                if (!isMobile) {
                  const scrollIdDer = setInterval(() => {
                    refe.current.scrollBy({ left: 160, top: 0, behaviour: 'smooth' });
                  }, 150);
                  setScrollId(scrollIdDer);
                }
                return null;
              }}
              onClick={() => {
                if (!isMobile) {
                  refe.current.scrollBy({ left: 160, top: 0, behaviour: 'smooth' });
                  return null;
                }
                if (mobileCardInView < products.length - 1 && isMobile) {
                  setMobileCardInView(mobileCardInView + 1);
                  centerCard(mobileCardInView + 1);
                }
                return null;
              }}
              onMouseUp={() => {
                if (!isMobile) {
                  clearInterval(scrollId);
                }
              }}
              onMouseLeave={() => {
                if (!isMobile) {
                  clearInterval(scrollId);
                }
              }}
            />
          </ButtonContainer>
        </CardsScrollArea>
      </OverflowWrapper>
    </>
  );
};

export { CardSelector };
